var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwitterLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29.475,
    height: 23.953,
    viewBox: "0 0 29.475 23.953",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1312",
    d: "M9.27 23.963c11.122 0 17.206-9.216 17.206-17.206 0-.262-.005-.522-.017-.781a12.265 12.265 0 0 0 3.016-3.131A12.107 12.107 0 0 1 26 3.8 6.071 6.071 0 0 0 28.662.452a12.087 12.087 0 0 1-3.839 1.468 6.05 6.05 0 0 0-10.461 4.136 5.966 5.966 0 0 0 .157 1.379A17.173 17.173 0 0 1 2.051 1.116a6.051 6.051 0 0 0 1.872 8.073 6 6 0 0 1-2.738-.757v.077a6.051 6.051 0 0 0 4.851 5.929 6.048 6.048 0 0 1-2.731.1 6.057 6.057 0 0 0 5.649 4.2 12.138 12.138 0 0 1-7.51 2.588A12.313 12.313 0 0 1 0 21.248a17.128 17.128 0 0 0 9.27 2.715",
    transform: "translate(0 -.01)",
    style: {
      fill: "#fff"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitterLogo);
export default __webpack_public_path__ + "static/media/twitter_logo.6ff2194e.svg";
export { ForwardRef as ReactComponent };